/* eslint-disable */
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { toRaw } from 'vue';
import { getMenuData } from "@/services/backend/backend.service";
import { recAddRoutes, addSubAppViewDynamic } from '@/services/router/router.service';
// import {introNew} from "../main"

// export const routes: Array<RouteRecordRaw> = [];
export const routes: Array<any> = [];


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  base: window.__POWERED_BY_SYDONE__ ? '/dashboard-overview-3' : '/',
  routes,
  // eslint-disable-next-line
  scrollBehavior(to: any, from: any, savedPosition: any) {
    return savedPosition || { left: 0, top: 0 };
  },
});

router.beforeEach(async (to:any, from:any, next:any) => {
  if(to.path.includes("eagente") && to.matched[0].name == "catchAll") {
     //HERE FETCH FOR EAGENTE ROUTES
    const extraRoutes = await getMenuData(
      "3126033173977255197", null
    );
    const menuData = toRaw(extraRoutes.value[0]);
    const extraAppRoutes = recAddRoutes(menuData);
    //@ts-ignore
    addSubAppViewDynamic(extraAppRoutes.map(route => route.path));
    router.push(to.fullPath);
  } else if(to.fullPath == "/") {
    router.push("/iam");
  } else {
  return next()
  }
});

router.afterEach(async (to: any, from: any) => {
  // if go from eagente to another app -> reload
  if(!to.path.includes("eagente") && from.path.includes("eagente")) {
    location.reload();
  } else if(to.path.includes("eagente") && from.path.includes("contact")) {
    //const targetOrigin = window.location.origin;
    //window.postMessage("eagenteMenu", targetOrigin);
    location.reload();
  }
  // hide hints after navigation
  //@ts-ignore
  // introNew.hideHints();
  if(to.fullPath.includes("management") || to.fullPath.includes("print")) {
    // @ts-ignore
    document.getElementById(process.env.VUE_APP_PUBLISHED_NAME).classList.remove("hidden");
  }
});

export default router;
